import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

document.addEventListener('DOMContentLoaded', function() {
    const wucSection = document.querySelectorAll('.why-choose-us-section');

    wucSection.forEach((section) => {
        const wcuSlider = section.querySelector('.wcus-slider');
        new Swiper(wcuSlider, {
            slidesPerView: 1.23,
            spaceBetween: 24,
            navigation: {
                nextEl: section.querySelector('.wcus-button-next'),
                prevEl: section.querySelector('.wcus-button-prev'),
            },
            scrollbar: {
                el: section.querySelector('.wcus-scrollbar'),
                draggable: true,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2.23,
                    spaceBetween: 32,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
                1200: {
                    slidesPerView: 3.56,
                    spaceBetween: 40,
                },
            },
        });

        section.querySelectorAll('.wcus-card-clickable').forEach((card) => {
            card.addEventListener('click', function() {
                const galleryId = card.dataset.galleryId;
                if (!galleryId) {return;}

                const galleryLinks = document.querySelectorAll(
                    '#' + galleryId + ' a',
                );
                if (galleryLinks.length === 0) {return;}

                Fancybox.show(
                    Array.from(galleryLinks).map((a) => ({
                        src: a.href,
                        type: 'image',
                    })),
                );
            });
        });
    });
});
